module.exports = __webpack_public_path__ + "img/6.25e7b797.png";